import { belongsTo, attr } from '@ember-data/model';
import ShModel from './sh-model';

export default ShModel.extend({
  block: attr('boolean'),
  note: attr('string'),
  createdAt: attr('date'),
  updatedAt: attr('date'),

  //Relationships
  blockedByUser: belongsTo('user', { async: false }),
  blocker: belongsTo('company', { async: false }),
  user: belongsTo('user', { async: false }),
});
